import React, { Component } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

export default class Number extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onChange({
      index: this.props.index,
      value: this.props.value,
    });
  }

  render() {
    return (
      <S.Number layout={this.props.layout}>
        <S.NumberValue inactive={!this.props.selected} onClick={this.onClick}>
          {this.props.value}
        </S.NumberValue>
      </S.Number>
    );
  }
}
Number.propTypes = {
  layout: PropTypes.oneOf(['vertical', 'horizontal']).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  selected: PropTypes.bool,
};

Number.defaultProps = {
  selected: true,
};
